export default "https://cdn-static.gokick.com/assets/34e3985c60c1a4021cd40bb2eb2cab3e4962f61f/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";